import { Routes, Route, Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { Container, Box, Breadcrumbs, Typography, Link } from '@mui/material';
import { useTeamsApi } from '@/context';
import TeamList from './TeamList';
import TeamForm from './TeamForm';
import TeamSettings from './TeamSettings';
import InviteAcceptance from './InviteAcceptance';
import TeamMemberDetails from './TeamMemberDetails';

function TeamEditor() {
  const apiClient = useTeamsApi();
  const navigate = useNavigate();
  const { teamSlug } = useParams();
  return (
    <Container maxWidth="md">
      <Box py={3}>
        <Breadcrumbs sx={{ mb: 2 }}>
          <Link color="inherit" component={RouterLink} to="/teams/">
            Teams
          </Link>
          <Typography color="text.primary">{teamSlug ? `Details: ${teamSlug}` : 'Create Team'}</Typography>
        </Breadcrumbs>
        <TeamForm
          key={teamSlug || 'new'}
          apiClient={apiClient}
          onSave={() => window.location.assign('/teams/')}
          onCancel={() => navigate('/teams/')}
        />
      </Box>
    </Container>
  );
}

export default function TeamsPage() {
  const apiClient = useTeamsApi();
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Container maxWidth="lg">
            <Box py={3}>
              <TeamList apiClient={apiClient} />
            </Box>
          </Container>
        }
      />
      <Route path="/new" element={<TeamEditor />} />
      <Route path="/edit/:teamSlug" element={<TeamEditor />} />
      <Route path="/settings/:teamSlug" element={<TeamSettings />} />
      <Route path="/accept/:invitationId" element={<InviteAcceptance />} />
      <Route path="/member/:teamSlug/:memberId" element={<TeamMemberDetails />} />
    </Routes>
  );
}
